import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ToggleGroup from '/@/components/forms/toggle-group';
import Section from '/@/components/section';
import Title from '/@/components/title';
import { _ } from '/@/locale';
import BarChart from '../../charts/bar-chart';
import styles from './styles.module.css';

@autobind
export default class Humidity extends Component {
    static propTypes = {
        user: PropTypes.shape({
            email: PropTypes.string.isRequired,
        }).isRequired,
        headToHeads: PropTypes.arrayOf(PropTypes.object).isRequired,
        brands: PropTypes.arrayOf(PropTypes.number),
        brandOptions: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.number.isRequired,
                label: PropTypes.string.isRequired,
            })
        ),
        setBrands: PropTypes.func,
    };

    static defaultProps = {
        brandOptions: [],
    };

    render() {
        return (
            <Section title={_('Humedad')}>
                <div className={styles.root}>
                    {this.renderFilters()}
                    {this.renderChart()}
                </div>
            </Section>
        );
    }

    renderFilters() {
        const { brands, brandOptions, setBrands } = this.props;

        return (
            <div className={styles.filters}>
                {brandOptions.length > 0 && (
                    <div className={styles.filter}>
                        <Title>{_('Marca')}</Title>
                        <ToggleGroup type='checkbox' options={brandOptions} value={brands} onChange={setBrands} />
                    </div>
                )}
            </div>
        );
    }

    renderChart() {
        const { headToHeads, user } = this.props;
        return <BarChart data={headToHeads} renderValue={(value) => `${value.toFixed(0)}%`} user={user} />;
    }
}
